<template>
  <div>
    <el-tabs class="tab tabCon" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="已付账单" name="first">
        <div class="conBor">
          <el-table :data="billData" stripe style="width: 100%">
            <el-table-column fixed prop="examNo" label="编号"></el-table-column>
            <el-table-column fixed prop="signPayTutDtos[tutorialName]" label="明细"></el-table-column>
            <el-table-column prop="price" label="合计"></el-table-column>
            <el-table-column prop="payType" label="支付方式"></el-table-column>
            <el-table-column prop="date" label="支付时间"></el-table-column>
          </el-table>
        </div>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="100"
            layout="prev, pager, next, jumper"
            :total="1000"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 5,
      activeName: "first",
      billData: []
    };
  },
  created() {
    console.log(localStorage.getItem("token"));
    this.billList();
  },
  methods: {
    handleClick(event) {
      this.typeId = event.index;
      if (event.index == 0) {
        this.typeId = null;
      }
      console.log(this.typeId);
      this.billList();
    },
    billList() {
      console.log(11);
      let me = this;
      let data = {
        bill: this.typeId
      };
      window.Global.get("/sign/payInfo", data, rs => {
        console.log(rs.data.result);
        if (rs.data.success) {
          me.billData = rs.data.result;
        } else {
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style lang="less">
@import "../../static/less/tutorial.less";
</style>



// WEBPACK FOOTER //
// src/components/BillDetail.vue